export default __webpack_public_path__ + "static/media/gallery-2.a45a4840.jpg";